export const Routes = {
  ROOT: '/',
  ACTIVITY: '/activity',
  AUTH_CONFIRM: '/auth/confirm',
  AUTH_CONSENT: '/auth/consent',
  AUTH_CREATE_INTERESTS_SURVEY: '/auth/create/interests-survey',
  PWA_ONBOARDING: '/auth/pwa-onboarding',
  AUTH_CREATE_PROFILE: '/auth/create/profile',
  AUTH_EMAIL: '/auth/email',
  AUTH_LOGIN: '/auth/log-in-option',
  AUTH_PHONE: '/auth/phone',
  AUTH_SIGN_UP: '/auth/sign-up-option',
  COMMENTS: '/comments/:activityId',
  CONTEST_EDITOR: '/contest-editor',
  CONTEST_DETAIL: '/contest/:contestId/',
  CONTEST_DETAIL_VIDEOS: '/contest/:contestId/video/:videoId',
  CONTEST_LEADERBOARD: '/contest/:contestId/leaderboard',
  CONVERSATION_CREATE: '/conversation',
  CONVERSATION_MANAGE: '/conversations/:conversationId',
  CONVERSATION_REPLY: '/conversations/:conversationId/reply',
  CUSTOM_REWARDS: '/custom-rewards',
  DISCOVER: '/discover',
  FEED: '/feed',
  LIKES: '/likes/:activityId',
  LOGIN: '/login',
  LOGOUT: '/logout',
  MESSAGES: '/messages',
  MESSAGES_USER: '/messages/:userId',
  MESSAGES_FIND_USERS: '/messages/find-users',
  POST: '/post',
  PROFILE: '/profile',
  PROFILE_EDIT: '/edit-profile',
  SECURITY_SETTINGS: '/security-settings',
  SETUP_2FA: '/setup-2fa',
  STAKE: '/stake',
  REMOVE_2FA: '/remove-2fa',
  PROFILE_USER: '/profile/:userId',
  RELATIONS_USER: '/relations/:userId',
  VALIDATE_EMAIL: '/validate-email',
  VAULT: '/vault',
  SSO_FACEBOOK_AUTHORIZE: '/authorize',
  FACE_LIVENESS_CHECK: '/liveness/check',
  FACE_LIVENESS_INSTRUCTIONS: '/liveness/instructions',
  FACE_LIVENESS_FAILED: '/liveness/failed',
  WITHDRAW: '/withdraw',
  DEPOSIT: '/deposit',
  STAKE_VAULT: '/stake-vault',
} as const
